import React, { useEffect } from "react";
import Instagram from "../assets/Instagram";
import Facebook from "../assets/Facebook";
import Tiktok from "../assets/Tiktok";
import Logo from "../assets/mainlogo.png";
import middle from "../assets/BlogTwo/Middletest.jpg";
import bottom from "../assets/BlogTwo/Bottom.jpg";
import bottomMobile from "../assets/BlogTwo/blog-2-bottom.png";
import MobileTop from "../assets/BlogTwo/blog-2-top.png";
import TagManager from "react-gtm-module";

const gtmId = "GTM-T4QRDGLB";
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};

const BlogTwo = () => {
  useEffect(() => {
    initializeTagManager();
  }, []);

  return (
    <>
      <div className="navbar-blogTwo ">
        <div className="nav-logo-div">
          <img alt="TheBooker Logo" src={Logo} />
        </div>
      </div>

      <div className="blogTwo-top-img column flex-center">
        <img
          src={MobileTop}
          style={{ maxWidth: "100%", height: "auto" }}
          alt="TheBookerBlogTwo"
        />
      </div>

      <div className="blogTwo-intro-bg">
        <div className="blogTwo-intro">
          <div>
            <h1>
              <span className="Benefits">5 Benefits</span>
              <br />
              of Having a Booking
              <br />
              System for Personal
              <br />
              Care Businesses
            </h1>
            <p className="light-text blogTwo-intro-p">
              <span className="p-bold" style={{ fontFamily: "Hurme-SemiBold" }}>
                TheBooker
              </span>{" "}
              - July 22 - 2024
            </p>
          </div>
        </div>

        <div>
          <p className="blogTwo-intro-p" style={{ textAlign: "start" }}>
            In today’s fast-paced and digitally-driven world, convenience and
            efficiency are keys to success, especially when it comes to personal
            care services. Whether you run a hair salon, physiotherapy clinic,
            or any other personal care business, implementing a booking system
            such as TheBooker app’s built-in solution can revolutionize the way
            you do business and manage relationship with your clients, and even
            your team.
            <br />
            Here are five compelling benefits of having a booking system for
            personal care businesses:
          </p>
        </div>
      </div>

      <div className="blogTwo-body">
        <ul className="BlogTwoUL">
          <li id="First" className="BlogTwoList1">
            <div className="blogTwoListConatiner">
              <div className="blogTwo-list">
                <h1>1.Efficient Appointment Scheduling, 7/24:</h1>
                <br />
              </div>
              <div>
                <p className="blogTwo-list-p">
                  Gone are the days of endless phone calls and back-and-forth
                  communication to schedule and confirm appointments. With a
                  booking system, clients can easily view available time slots
                  and book appointments at their convenience. This not only
                  saves time for both clients and service providers, but also
                  reduces the likelihood of double bookings and scheduling
                  conflicts.
                  <br />
                  TheBooker’s 7/24 appointment making feature allows clients to
                  book appointments anytime, anywhere, using their smartphones.
                  This accessibility ensures that you capture potential clients
                  who prefer to book outside of traditional business hours,
                  ultimately boosting your customer base and revenue.
                </p>
              </div>
            </div>
          </li>

          <li id="Second" className="BlogTwoList2">
            <div>
              <div className="blogTwoListConatiner">
                <div className="blogTwo-list">
                  <h1>
                    2.Improved Client <wbr />
                    Experience:
                  </h1>
                  <br />
                </div>
                <div>
                  <p className="blogTwo-list-p">
                    A seamless booking enhances the overall client experience.
                    Clients appreciate the convenience of booking appointments
                    online, and a user-friendly booking system can leave a
                    positive impression of your business. Moreover, TheBooker
                    goes one step further by delivering to your clients gentle
                    reminders so that they stay on top of their schedules and
                    prioritize their appointments with your business. TheBooker
                    also allows you to avoid having your or your team members’
                    valuable time and energy be spread too thin on time
                    consuming tasks that are prone to human error.
                  </p>
                </div>
              </div>
            </div>
          </li>

          <li id="Third" className="BlogTwoList3">
            <div className="blogTwoListConatiner">
              <div className="blogTwo-list">
                <h1>3.Enhanced Organization and Efficiency:</h1>
                <br />
              </div>
              <div>
                <p className="blogTwo-list-p">
                  Managing appointments manually can be a logistical nightmare,
                  leading to errors and inefficiencies. A booking system
                  automates the appointment management process, allowing you to
                  easily track appointments, manage client information, and
                  monitor staff schedules. This streamlines your operations,
                  freeing up time for you and your staff to focus on delivering
                  exceptional service.
                </p>
              </div>
            </div>
          </li>

          <li id="4th" className="BlogTwoList4">
            <div className="blogTwoListConatiner">
              <div className="blogTwo-List4">
                <div className="blogTwo-content">
                  <div className="blogTwo-list">
                    <h1>4.Data-Driven Insights:</h1>
                    <br />
                  </div>
                  <p
                    className="blogTwo-list-p blogTwo-list-p4"
                    style={{ marginTop: 0, lineHeight: 1.4, color: "black" }}
                  >
                    A booking system provides valuable insights into your
                    business operations and client preferences. By analyzing
                    appointment data, you can identify trends, optimize staff
                    schedules, and tailor your services to better meet the needs
                    of your clients. TheBooker’s data-driven approach empowers
                    you to make informed decisions that drive business
                  </p>
                </div>
                <div className="imageblogtwo-container ">
                  <img src={middle} alt="Insight" />
                </div>
              </div>
            </div>
          </li>

          <li id="5th" className="BlogTwoList5">
            <div className="blogTwoListConatiner">
              <div className="blogTwo-list5">
                <div className="blogTwo-list">
                  <h1>
                    5.Access to <wbr />
                    Business Growth Tools:
                  </h1>
                  <br />
                </div>
                <div>
                  <p className="blogTwo-list-p">
                    In addition to all the benefit of having a digital/mobile
                    booking system, TheBooker puts at your fingertips uniquely
                    designed marketing tools to grow your personal care
                    business. As a business on TheBooker app, you will be
                    present in an eco-system of interested new clients,
                    repeat-clients, and potential prospects. In addition, you
                    will get a chance to increase your exposure through various
                    tools such as promotions and advertisements.
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <img src={bottom} alt="" className="BlogTwoBottomPic" />
        <img src={bottomMobile} alt="" className="BlogTwoBottomPicMobile" />

        <div className="blogTwo-conclusion" style={{ padding: "20px 0" }}>
          <p
            className="blogTwo-list-p"
            style={{
              fontSize: "19px",
              margin: "0 0 0 8%",
              maxWidth: "80%",
            }}
          >
            In conclusion, implementing a booking system for your personal care
            business offers many benefits, ranging from improved efficiency and
            organization to enhanced client experience and business growth.
            Embrace the power of technology in our digital times to take your
            business to new heights and stay ahead in today’s competitive
            market. Ready to revolutionize your personal care business? Join us
            now by submitting your details{" "}
            <a
              href="https://thebooker.online/#business"
              style={{ color: "#008a80" }}
            >
              here
            </a>
            , and a member of our team will get in touch with you as soon as
            possible!
          </p>
        </div>
        <div className="blog-footer">
          <div>
            <a
              href="https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram width={30} height={30} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61558283653706"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook width={30} height={30} />
            </a>
            <a
              href="https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1"
              target="_blank"
              rel="noreferrer"
            >
              <Tiktok width={30} height={30} />
            </a>
          </div>
          <div>
            <p>TheBooker App. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogTwo;
